<div class="app-container-header px-3 d-flex align-items-center">
    <ng-content></ng-content>
</div>